import { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

export interface KeyMetricsProps extends ComponentProps<"div"> {
  title: string;
  value: string | number;
  isActive?: boolean;
}

export const KeyMetrics = ({
  title,
  value,
  className,
  isActive,
  ...props
}: KeyMetricsProps) => {
  return (
    <div
      {...props}
      className={twMerge(
        "w-[8.63319rem] h-[5.98838rem] rounded bg-gray-100 shadow-md flex flex-col items-center justify-between py-[0.85em] px-[0.6rem]",
        isActive && "bg-[#1d1d1b]"
      )}
    >
      <p className="text-[#e84e1b] text-center text-sm font-bold leading-5">
        {title}
      </p>
      <span
        className={twMerge(
          isActive ? "text-white" : "text-[#1d1d1b]",
          "text-center text-xl font-bold leading-5"
        )}
      >
        {value}
      </span>
    </div>
  );
};
